export default "__VITE_ASSET__DR3x0FxA__"